export default __webpack_public_path__ + "static/fota-c7456b10febecee35b04f46744f1cc0d.mp4";